import styled from '@emotion/styled';
import { Colors, helperLinkReset, helperButtonReset, helperListItemHover } from '@utex/ui-kit';

export const Container = styled('div')`
  margin-bottom: 1rem;
`;
interface ItemSecondProps {
  href?: string;
  target?: string;
  isDisabled?: boolean;
}

export const ItemSecond = styled('a')<ItemSecondProps>`
  ${helperButtonReset};
  ${helperLinkReset};
  display: block;
  padding: 0.7rem 2.4rem 0.7rem 6.9rem;
  width: 100%;
  text-align: left;
  font-size: 1.3rem;
  line-height: 1.69;
  color: ${(props) => props.isDisabled && Colors.text.disabled};
  cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};

  ${(props) =>
    !props.isDisabled &&
    helperListItemHover({
      activeBgColor: Colors.ut.listItemDown,
    })};
`;
